import { useRef, useState, useEffect } from "react";

import {
  faCheck,
  faTimes,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./UserRegistration.css";
import useAuth from "../../hooks/useAuth";
import { useNavigate, Link } from "react-router-dom";
import useLogout from "../../hooks/useLogout";
import TopBar from "./TopBar";

const USER_REGEX = /^[A-z][A-z0-9-_]{3,23}$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
const EMAIL_REGEX =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
const NAME_REGEX = /^(?!\s*$).+/;
const REGISTER_URL = "api/user-signup";


const UserRegistration = () => {


  const back = async (e) => {
    e.preventDefault();
    setSuccess(false);
    setUser("");
    setEmail("");
    setRole("");
    setName("");
    setPwd("");
    setMatchPwd("");
  };

  const axiosPrivate = useAxiosPrivate();
  const userRef = useRef();
  const errRef = useRef();
  const { auth } = useAuth();

  const [user, setUser] = useState("");
  const [name, setName] = useState("");
  const [role, setRole] = useState("");
  const [email, setEmail] = useState("");

  const [validEmail, setValidEmail] = useState(false);
  const [validName, setValidName] = useState(false);
  const [validRole, setValidRole] = useState(false);
  const [validUserName, setValidUserName] = useState(false);

  const [nameFocus, setNameFocus] = useState(false);
  const [userFocus, setUserFocus] = useState(false);
  const [pwdFocus, setPwdFocus] = useState(false);
  const [emailFocus, setEmailFocus] = useState(false);
  const [roleFocus, setRoleFocus] = useState(false);
  const [matchFocus, setMatchFocus] = useState(false);

  const [pwd, setPwd] = useState("");
  const [validPwd, setValidPwd] = useState(false);

  const [matchPwd, setMatchPwd] = useState("");
  const [validMatch, setValidMatch] = useState(false);

  const [errMsg, setErrMsg] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    userRef.current.focus();
  }, []);

  useEffect(() => {
    setValidUserName(USER_REGEX.test(user));
  }, [user]);

  useEffect(() => {
    setValidName(NAME_REGEX.test(name));
  }, [name]);

  useEffect(() => {
    setValidRole(NAME_REGEX.test(role));
  }, [role]);

  useEffect(() => {
    setValidEmail(EMAIL_REGEX.test(email));
  }, [email]);

  useEffect(() => {
    setValidPwd(PWD_REGEX.test(pwd));
    setValidMatch(pwd === matchPwd);
  }, [pwd, matchPwd]);

  useEffect(() => {
    setErrMsg("");
  }, [user, pwd, matchPwd]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // if button enabled with JS hack
    const v1 = USER_REGEX.test(user);
    const v2 = PWD_REGEX.test(pwd);
    if (!v1 || !v2) {
      setErrMsg("Invalid Entry");
      return;
    }
    // console.log(auth);

    try {
      var data = JSON.stringify({
        name,
        username: user,
        email,
        password: pwd,
        role,
        franchise_id: auth.franchise_id
      });

      const response = await axiosPrivate.post(REGISTER_URL, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });
      // TODO: remove console.logs before deployment
      // console.log(JSON.stringify(response?.data));
      //console.log(JSON.stringify(response))
      setSuccess(true);
      alert("User successfully registred !")
      //clear state and controlled inputs
      setUser("");
      setEmail("");
      setRole("");
      setName("");
      setPwd("");
      setMatchPwd("");
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.status === 409) {
        setErrMsg(err.response?.data.message);
      } else {
        setErrMsg("Registration Failed! \n" + err.response?.data.message);
      }
      errRef.current.focus();
    }
  };

  const navigate = useNavigate();
  const logout = useLogout();

  const handleRedirect2 = () => {
    navigate("/ListUsers");
  }

  return (
    <>
      <section className="userregbody">
        <p
          ref={errRef}
          className={errMsg ? "errmsg" : "offscreen"}
          aria-live="assertive"

        >
          {errMsg}
        </p>

        <div className=" wrapper10">
          <div className="d-flex align-items-center">
            {/* Left */}
            <button
              onClick={() => navigate(-1)}
              className="btn btn-secondary newviewbtn"
            >
              ← Back
            </button>

            {/* Right */}
            <div className="d-flex gap-2 ms-auto">
              <button
                onClick={handleRedirect2}
                type="button"
                className="btn btn-success top-bt"
              >
                List Users
              </button>

            </div>
          </div>
          <form onSubmit={handleSubmit}> {/* Add onSubmit handler to trigger login */}

            <h3>Create User</h3>
            <Row> <Col>

              <div className=" input-boxs">
                <label htmlFor="name">Name<sup>*</sup></label>

                <input
                  type="text"
                  id="name"
                  placeholder=""
                  autoComplete="off"
                  ref={userRef} // Attach the ref to this input

                  onChange={(e) => setName(e.target.value)}
                  value={name}
                  required
                  aria-invalid={validName ? "false" : "true"}
                  aria-describedby="namenote"
                  onFocus={() => setNameFocus(true)}
                  onBlur={() => setNameFocus(false)}
                />
                {/* <i className="bx bxs-user"></i> */}
                <p
                  id="namenote"
                  className={
                    nameFocus && name && !validName ? "instructions" : "offscreen"
                  }
                >
                  <FontAwesomeIcon icon={faInfoCircle} />
                  Name is required!.
                </p>

              </div>
            </Col>
              <Col>



                <div className=" input-boxs">
                  <label htmlFor="email">Email<sup>*</sup></label>

                  <input
                    type="text"
                    id="email"
                    autoComplete="off"
                    placeholder=""

                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    required
                    aria-invalid={validEmail ? "false" : "true"}
                    aria-describedby="emailnote"
                    onFocus={() => setEmailFocus(true)}
                    onBlur={() => setEmailFocus(false)}

                  />
                  {/* <i className="bx bxs-lock-alt"></i> */}
                  <p
                    id="emailnote"
                    className={
                      emailFocus && email && !validEmail
                        ? "instructions"
                        : "offscreen"
                    }
                  >
                    <FontAwesomeIcon icon={faInfoCircle} />
                    E-mail is required!.
                  </p>

                </div>
              </Col></Row>

            <Row><Col>
              <div className=" input-boxs">
                <label htmlFor="role">Role<sup>*</sup></label>
                <select className="newregselect"
                  name="role"
                  required
                  aria-invalid={validRole ? "false" : "true"}
                  aria-describedby="rolenote"
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                  onFocus={() => setRoleFocus(true)}
                  onBlur={() => setRoleFocus(false)}
                >
                  <option value="">Select Role</option>
                  <option value="User">User</option>

                </select>
                <p
                  id="rolenote"
                  className={
                    roleFocus && role && !validRole ? "instructions" : "offscreen"
                  }
                >
                  <FontAwesomeIcon icon={faInfoCircle} />
                  Role is required!.
                </p>

              </div>

            </Col>
              <Col>

                <div className=" input-boxs">
                  <label htmlFor="Username">Username<sup>*</sup></label>
                  <input
                    type="text"
                    id="username"
                    autoComplete="off"
                    placeholder=""

                    onChange={(e) => setUser(e.target.value)}
                    value={user}
                    required
                    aria-invalid={validUserName ? "false" : "true"}
                    aria-describedby="usernamenote"
                    onFocus={() => setUserFocus(true)}
                    onBlur={() => setUserFocus(false)}
                  />
                  {/* <i className="bx bxs-lock-alt"></i> */}
                  <p
                    id="usernamenote"
                    className={
                      userFocus && user && !validUserName
                        ? "instructions"
                        : "offscreen"
                    }
                  >
                    <FontAwesomeIcon icon={faInfoCircle} />
                    4 to 24 characters.
                    <br />
                    Must begin with a letter.
                    <br />
                    Letters, numbers, underscores, hyphens allowed.
                  </p>
                </div>
              </Col></Row>


            <Row><Col>

              <div className=" input-boxs">
                <label htmlFor="password">Password<sup>*</sup></label>
                <input
                  type="password"
                  id="password"
                  autoComplete="off"
                  placeholder=""

                  onChange={(e) => setPwd(e.target.value)}
                  value={pwd}
                  required
                  aria-invalid={validPwd ? "false" : "true"}
                  aria-describedby="pwdnote"
                  onFocus={() => setPwdFocus(true)}
                  onBlur={() => setPwdFocus(false)}
                />
                {/* <i className="bx bxs-lock-alt"></i> */}
                <p
                  id="pwdnote"
                  className={pwdFocus && !validPwd ? "instructions" : "offscreen"}
                >
                  <FontAwesomeIcon icon={faInfoCircle} />
                  8 to 24 characters.
                  <br />
                  Must include uppercase and lowercase letters, a number and a
                  special character.
                  <br />
                  Allowed special characters:{" "}
                  <span aria-label="exclamation mark">!</span>{" "}
                  <span aria-label="at symbol">@</span>{" "}
                  <span aria-label="hashtag">#</span>{" "}
                  <span aria-label="dollar sign">$</span>{" "}
                  <span aria-label="percent">%</span>
                </p>

              </div>
            </Col>
              <Col>



                <div className=" input-boxs">
                  <label htmlFor="confirm_pwd">Password<sup>*</sup></label>
                  <input
                    type="password"
                    id="confirm_pwd"
                    autoComplete="off"
                    placeholder=" "

                    onChange={(e) => setMatchPwd(e.target.value)}
                    value={matchPwd}
                    required
                    aria-invalid={validMatch ? "false" : "true"}
                    aria-describedby="confirmnote"
                    onFocus={() => setMatchFocus(true)}
                    onBlur={() => setMatchFocus(false)}
                  />
                  {/* <i className="bx bxs-lock-alt"></i> */}
                  <p
                    id="confirmnote"
                    className={
                      matchFocus && !validMatch ? "instructions" : "offscreen"
                    }
                  >
                    <FontAwesomeIcon icon={faInfoCircle} />
                    Must match the first password input field.
                  </p>
                </div>
              </Col></Row>
            <center> <button type="submit" className="btn regbutton"
              disabled={
                !validName ||
                  !validEmail ||
                  !validUserName ||
                  !validPwd ||
                  !validMatch
                  ? true
                  : false
              }
            >Create</button></center>
          </form>
        </div>
      </section>

      <TopBar />
      {/* </Container> */}


    </>
  );
};

export default UserRegistration;
